import { mapState } from "pinia";
import { Container } from "aurelia-dependency-injection";
import { defineComponent } from "vue";

import { PalServiceLocations } from "../../../../../../../enums/enums";
import { enumToMap } from "../../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { formatDateInput } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { useConvertToPendingPal } from "../../../../store/useConvertToPendingPal";
import { ToastrService } from "../../../../../../../services/toastr.service";
import { LocationService } from "../../../../../../../services/location-service";

import FormSection from "../../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import DatePicker from "../../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";
import TimePicker from "../../../../../../../resources-vue/vue-custom-elements/TimePicker/TimePicker.vue";

export default defineComponent({
    components: {
        FormSection,
        DatePicker,
        TimePicker
    },
    props: {
        resetList: {
            type: Function
        },

        closeServiceForm: {
            type: Function
        },
        showServiceForm: {
            type: Boolean
        },

        service: {
            type: Object
        },
        openEditServiceLocation: {
            type: Function
        },
        closeEditService: {
            type: Function
        },
        isEdit: {
            type: Boolean
        }
    },

    data() {
        return {
            ServiceLocations: enumToMap(PalServiceLocations),
            _serviceLocationService: null,
            _toastrService: null,
            isLoading: false,
            formatDateInput
        };
    },

    created() {
        this._serviceLocationService = Container.instance.get(LocationService);
        this._toastrService = Container.instance.get(ToastrService);
    },
    computed: {
        ...mapState(useConvertToPendingPal, ["application", "patientDetails", "accountId", "patientId"])
    },

    methods: {
        onDateChange(date: any, name: any) {
            this.service.Start = date;
        },

        onDateInputChange(e: any) {
            const name = e.target.name;
            const value = e.target.value;
            this.onDateChange(value, name);
        },
        changeStartTime(time: any) {
            this.service.StartTime = time;
        },

        handleSave() {
            if (this.isEdit) {
                this.editServiceLocation();
            } else {
                this.saveServiceLocation();
            }
        },

        handleCancel() {
            if (this.isEdit) {
                this.closeEditService();
            } else {
                this.resetServiceForm();
                this.closeServiceForm();
            }
        },

        async saveServiceLocation() {
            try {
                this.isLoading = true;
                await this._serviceLocationService.saveServiceLocations(this.patientId, {
                    agencyId: this.accountId,
                    application: this.application,
                    Code: this.service.Code,
                    Start: this.service.Start,
                    StartTime: this.service.StartTime
                });
                this.resetServiceForm();
                this.closeServiceForm();
                this._toastrService.success({
                    title: `Service Location added successfully`
                });
                this.resetList();
                this.isLoading = false;
            } catch (e) {
                console.error(e);
                this._toastrService.error({
                    title: `Error`,
                    message: `There was a problem while saving the service. Please try again.`
                });
            } finally {
                this.isLoading = false;
            }
        },
        resetServiceForm(){
            this.service.Code = null;
            this.service.Start = null;
            this.service.StartTime = null;
        },

        async editServiceLocation() {
            try {
                this.isLoading = true;
                const payload = {
                    ...this.service,
                    agencyId: this.accountId,
                    application: this.application
                };

                const response = await this._serviceLocationService.editServiceLocation(
                    payload,
                    this.patientId,
                    this.service.Id
                );
                if (response.isSuccess == true) {
                    this.closeEditService();
                    this.resetList();
                    this.isLoading = false;
                    this._toastrService.success({
                        title: "Success",
                        message: "The Service location updated successfully.!"
                    });
                } else {
                    this._toastrService.error({
                        title: "Error",
                        message: "There was a problem while editing service location. Please try again."
                    });
                }
            } catch (err) {
                console.error(err);
                this._toastrService.error({
                    title: `Error`,
                    message: `There was a problem while editing the service. Please try again.`
                });
            } finally {
                this.isLoading = false;
            }
        }
    }
});
